import { PolicyDecisionActionTypes } from "@iddataweb/idw-common-ui/enums";
import { SelectOption } from "@idw-types/common";

export const POLICY_DECISION_ACTION_TYPE_OPTIONS: Array<SelectOption> = [
    { label: "APPROVE", value: PolicyDecisionActionTypes.APPROVE },
    { label: "DENY", value: PolicyDecisionActionTypes.DENY },
    { label: "OBLIGATION", value: PolicyDecisionActionTypes.OBLIGATION }
];